import { useEffect } from 'react';

const upsertMeta = (name, content, attr = 'name') => {
    if (!content) {
        return;
    }

    let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
    }

    tag.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
    if (!href) {
        return;
    }

    let tag = document.head.querySelector(`link[rel="${rel}"]`);
    if (!tag) {
        tag = document.createElement('link');
        tag.setAttribute('rel', rel);
        document.head.appendChild(tag);
    }

    tag.setAttribute('href', href);
};

const SeoHead = ({ title, description, canonical, schema }) => {
    useEffect(() => {
        if (title) {
            document.title = title;
        }

        upsertMeta('description', description);
        upsertMeta('og:title', title, 'property');
        upsertMeta('og:description', description, 'property');
        upsertMeta('og:type', 'website', 'property');
        upsertMeta('twitter:card', 'summary_large_image');

        if (canonical) {
            upsertLink('canonical', canonical);
            upsertMeta('og:url', canonical, 'property');
        }

        let schemaTag = document.head.querySelector('#mhe-seo-schema');
        if (!schemaTag) {
            schemaTag = document.createElement('script');
            schemaTag.type = 'application/ld+json';
            schemaTag.id = 'mhe-seo-schema';
            document.head.appendChild(schemaTag);
        }

        schemaTag.textContent = schema ? JSON.stringify(schema) : '';

        return () => {
            if (schemaTag) {
                schemaTag.textContent = '';
            }
        };
    }, [title, description, canonical, schema]);

    return null;
};

export default SeoHead;
